import React, { useContext, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { usePartner } from '@pcln/partner-config'
import { useFeature } from '@pcln/feature-components'
import { Flex, Radio } from 'pcln-design-system'
import BootstrapDataContext from '../../../context/BootstrapDataContext'
import {
  FLY_DRIVE,
  STAY_DRIVE,
  STAY_FLY_DRIVE,
  STAY_FLY,
  TripTypeInfos,
  TripTypeLabel
} from './TripTypes'
import { swap } from '../../../utils/ramda-helper'

const tripTypeProductMap = {
  [STAY_FLY]: ['hotel', 'flight'],
  [STAY_FLY_DRIVE]: ['hotel', 'flight', 'car'],
  [FLY_DRIVE]: ['flight', 'car'],
  [STAY_DRIVE]: ['hotel', 'car']
}

const defaultTripTypes = Object.values(TripTypeInfos)
const mobileDefaultTripTypes = swap(1, 2, defaultTripTypes)

const singleHotelTripTypes = defaultTripTypes.filter(
  type => ![FLY_DRIVE, STAY_DRIVE].includes(type.tripType)
)

const TripTypeRadios = ({ setValue, watchTripType, register }) => {
  const { isMobile = false } = useContext(BootstrapDataContext)
  const isPricelineOnly = useFeature('whiteLabel.isPricelineOnly')
  const products = usePartner('config.searchForm.products')
  const isSingleHotel = usePartner('config.products.hotel.singleLocation')
  const pricelineTripTypes = isMobile
    ? mobileDefaultTripTypes
    : defaultTripTypes
  const [tripTypes, setTripTypes] = useState(
    isSingleHotel ? singleHotelTripTypes : pricelineTripTypes
  )

  useEffect(() => {
    if (products) {
      const mandatoryProducts = Object.keys(products).filter(
        productKey => products[productKey].isMandatory
      )

      const mandatoryTrips = Object.keys(TripTypeInfos).filter(tripTypeKey =>
        mandatoryProducts.every(mandatoryProduct =>
          tripTypeProductMap[tripTypeKey].includes(mandatoryProduct)
        )
      )
      setTripTypes(mandatoryTrips.map(tripKey => TripTypeInfos[tripKey]))
    }
  }, [products])

  return (
    <Flex
      alignItems={['left', null, 'center']}
      flexDirection={['column', null, 'row']}
      justifyContent="space-between"
    >
      <Flex
        flexDirection={[isPricelineOnly ? 'row' : 'column', null, 'row']}
        flexWrap="wrap"
      >
        {tripTypes.map(typeInfo => (
          <Flex
            mr={[0, null, 3]}
            alignItems="center"
            key={typeInfo.id}
            width={isMobile ? 1 / 2 : 'auto'}
          >
            <TripTypeLabel fontSize={0} fontWeight={500} nowrap>
              <Radio
                id={typeInfo.id}
                type="radio"
                name="tripType"
                value={typeInfo.tripType}
                ref={register}
                checked={watchTripType === typeInfo.tripType}
                onChange={e => {
                  setValue('tripType', e.target.value)
                }}
              />{' '}
              {typeInfo.typeLabel}
            </TripTypeLabel>
          </Flex>
        ))}
      </Flex>
    </Flex>
  )
}

TripTypeRadios.propTypes = {
  setValue: PropTypes.func.isRequired,
  watchTripType: PropTypes.string.isRequired,
  register: PropTypes.func.isRequired
}
export default TripTypeRadios
